import { render, staticRenderFns } from "./basketballCupFull_FIBAMA.vue?vue&type=template&id=461749a0"
import script from "./basketballCupFull_FIBAMA.vue?vue&type=script&lang=js"
export * from "./basketballCupFull_FIBAMA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports